import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { SuggestionsHolder } from './styles';

const Suggestions = ({
  baseURL,
  queryStringOptions = '',
  suggestions = [],
}) => (
  <SuggestionsHolder>
    {`Try: `}
    {suggestions.map((t, i) => (
      <Fragment key={t}>
        <a href={`${baseURL}?query=${t}&${queryStringOptions}`}>{t}</a>
        {i !== suggestions.length - 1 && `, `}
      </Fragment>
    ))}
  </SuggestionsHolder>
);

Suggestions.propTypes = {
  baseURL: PropTypes.string.isRequired,
  queryStringOptions: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.string),
};

export default Suggestions;
